// Beat type colors are presentation, not player logic — each app owns its own
// palette. The shared player lib (src/lib/player/) must stay byte-identical
// with bubot_admin, so colors live here instead.
export const BEAT_TYPE_COLORS = {
  narrative: 'blue',
  input: 'teal',
  decision: 'orange',
  character_response: 'lime',
  narrative_response: 'green',
  resolution: 'indigo',
}

export const getBeatTypeColor = (beatType) => BEAT_TYPE_COLORS[beatType] || 'gray'
